
import { defineNuxtPlugin } from '#app'
import {
  Chart,
  LineController, LineElement, PointElement,
  LinearScale, TimeScale, // time scale is important
  Tooltip, Legend, Filler, Title,
} from 'chart.js'
import 'chartjs-adapter-date-fns' // enables time formatting/displayFormats

Chart.register(
  LineController, LineElement, PointElement,
  LinearScale, TimeScale,
  Tooltip, Legend, Filler, Title
)

export default defineNuxtPlugin(() => {
  // Optional global defaults
})


// import {
//   Chart,
//   Title,
//   Tooltip,
//   Legend,
//   BarElement,
//   CategoryScale,
//   LinearScale,
// } from 'chart.js'
//
// export default defineNuxtPlugin(() => {
//   // Register only what you use for smaller bundles
//   Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
// })


// import { defineNuxtPlugin } from '#app'
// import {
//   Chart,
//   BarController, BarElement, LineController, LineElement,
//   CategoryScale, LinearScale, PointElement, Tooltip, Legend,
//   Title,
// } from 'chart.js'
//
// // Register only what you need (tree-shaking friendly)
// Chart.register(
//   BarController, BarElement,
//   LineController, LineElement,
//   CategoryScale, LinearScale, PointElement,
//   Tooltip, Legend, Title
// )
//
// export default defineNuxtPlugin(() => {
//   // You can configure global defaults here if you want:
//   // Chart.defaults.font.family = 'Inter, sans-serif'
// })
